import { Directive, HostListener } from '@angular/core';

import { SnRouteStackService } from '../services';

@Directive({
  selector: '[snRouteForward]',
})
export class SnRouteForwardDirective {
  constructor(private readonly _routeStack: SnRouteStackService) {}

  @HostListener('click')
  public onClick(): void {
    this._routeStack.forward();
  }
}
